module.exports = __webpack_public_path__ + "static/media/tech-nextgen-1.f107684f.png";